import { BasicAutocompleteField } from '@forgeglobal/design-framework'
import React from 'react'

export const businessDevelopmentTierOpts = [...Array(4)].map((_, i) => ({ label: (i + 1).toString(), value: i + 1 }))
export const BusinessDevelopmentTierField: React.FC<{ name: string; label: string }> = ({ name, label }) => {
  return <BasicAutocompleteField name={name} label={label} options={businessDevelopmentTierOpts} />
}
